import React, { useEffect, useState, Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Calendar, MessageCircle, MapPin, Mail, Clock, ArrowRight, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
import { twMerge } from 'tailwind-merge';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services'];
function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Patient Information',
    path: '/patient-information'
  }, {
    name: 'Doctors & Staff',
    path: '/doctors'
  }, {
    name: 'Facilities',
    path: '/facilities'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={twMerge('fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white', isScrolled ? 'shadow-soft' : '')} data-id="element-228">
      {/* Top utility bar — desktop only */}
      <div className="hidden md:block bg-brand-gold text-white" data-id="element-229">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
          <div className="flex items-center justify-between h-10 text-sm" data-id="element-231">
            <div className="flex items-center gap-6" data-id="element-232">
              <span className="flex items-center gap-2" data-id="element-233">
                <Clock className="w-4 h-4 text-white/80" data-id="element-234" />
                Monday – Friday: 8:00 AM – 6:00 PM
              </span>
              <a href="mailto:bookings@maishahealth.co.bw" className="flex items-center gap-2 hover:text-white/80 transition-colors" data-id="element-235">
                <Mail className="w-4 h-4 text-white/80" data-id="element-236" />
                bookings@maishahealth.co.bw
              </a>
              <span className="flex items-center gap-2" data-id="element-237">
                <MapPin className="w-4 h-4 text-white/80" data-id="element-238" />
                Plot 5245, Tsabong, Botswana
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-239">
              {[{
              label: 'WhatsApp',
              href: 'https://wa.me/26773241613',
              Icon: MessageCircle
            }, {
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-7 h-7 rounded-full border border-white/50 flex items-center justify-center hover:bg-white hover:text-brand-gold transition-colors" data-id="element-240">
                  <Icon className="w-3.5 h-3.5" data-id="element-241" />
                </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation row */}
      <div className={twMerge('max-w-brand mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-300', isScrolled ? 'py-2' : 'py-4')} data-id="element-242">
        <div className="flex items-center justify-between" data-id="element-243">
          {/* Logo */}
          <Link to="/" className="flex items-center group shrink-0" data-id="element-244">
            <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-12 md:h-14 w-auto object-contain" data-id="element-245" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-246">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-247">
              Home
            </Link>
            <Link to="/about" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-248">
              About Us
            </Link>

            {/* Services Dropdown */}
            <div className="relative group" data-id="element-249">
              <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-250">
                Services <ChevronDown className="w-4 h-4" data-id="element-251" />
              </button>

              {servicesOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white shadow-soft-lg rounded-2xl p-6 grid grid-cols-2 gap-x-8 gap-y-3 border border-slate-100" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-252">
                  {SERVICES.map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600 hover:text-brand-red hover:translate-x-1 transition-all flex items-center gap-2" data-id="element-253">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/50" data-id="element-254" />
                      {service}
                    </Link>)}
                </div>}
            </div>

            <Link to="/patient-information" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-255">
              Patient Info
            </Link>
            <Link to="/doctors" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-256">
              Doctors
            </Link>
            <Link to="/facilities" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-257">
              Facilities
            </Link>
            <Link to="/blog" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-258">
              Blog
            </Link>
            <Link to="/faq" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-259">
              FAQ
            </Link>
            <Link to="/contact" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-260">
              Contact
            </Link>
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-261">
            <div className="hidden md:block" data-id="element-262">
              <Button href="/book" variant="primary" size="sm" icon={<Calendar className="w-4 h-4" data-id="element-264" />} data-id="element-263">
                Book Appointment
              </Button>
            </div>
            <button className="lg:hidden p-2 text-brand-navy hover:bg-slate-50 rounded-lg" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-265">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-266" /> : <Menu className="w-6 h-6" data-id="element-267" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-soft-lg border-t border-slate-100 max-h-[80vh] overflow-y-auto" data-id="element-268">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-269">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-brand-navy py-2 border-b border-slate-50" data-id="element-270">
                {link.name}
              </Link>)}
            <div className="py-2 border-b border-slate-50" data-id="element-271">
              <div className="text-lg font-medium text-brand-navy mb-3" data-id="element-272">
                Services
              </div>
              <div className="flex flex-col gap-3 pl-4" data-id="element-273">
                {SERVICES.slice(0, 8).map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600" data-id="element-274">
                    {service}
                  </Link>)}
                <Link to="/services" className="text-sm font-medium text-brand-red flex items-center gap-1 mt-2" data-id="element-275">
                  View All Services <ArrowRight className="w-4 h-4" data-id="element-276" />
                </Link>
              </div>
            </div>
            <Button href="/book" variant="primary" fullWidth className="mt-4" data-id="element-277">
              Book Appointment
            </Button>
          </div>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="bg-brand-navy text-white pt-20 pb-10" data-id="element-278">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-280">
          {/* Brand */}
          <div data-id="element-281">
            <Link to="/" className="inline-flex mb-6" data-id="element-282">
              <span className="bg-white rounded-2xl p-3 inline-flex" data-id="element-283">
                <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-16 w-auto object-contain" data-id="element-284" />
              </span>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6" data-id="element-285">
              Providing comprehensive healthcare services, diagnostics,
              physiotherapy, maternal care, and specialist consultations across
              Botswana.
            </p>
            <div className="flex items-center gap-4" data-id="element-286">
              {[{
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-287">
                  <Icon className="w-5 h-5 text-white" data-id="element-288" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-289">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-290">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-291">
              {['About Us', 'Patient Information', 'Doctors & Staff', 'Facilities', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-292">
                  <Link to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('&-', '')}`} className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-293">
                    <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-294" />
                    {item}
                  </Link>
                </li>)}
              <li data-id="element-295">
                <Link to="/privacy" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-296">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-297" />
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-298">
                <Link to="/terms" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-299">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-300" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-301">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-302">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-303">
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-304">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-305" />
                <span data-id="element-306">Plot 5245, Tsabong, Botswana</span>
              </li>
              <li className="flex flex-col gap-1 text-sm text-slate-300" data-id="element-307">
                <span className="flex items-center gap-3" data-id="element-308">
                  <Phone className="w-5 h-5 text-white shrink-0" data-id="element-309" />
                  <a href="tel:+2676540244" className="hover:text-brand-gold transition-colors" data-id="element-310">
                    +267 6540244
                  </a>
                </span>
                <span className="flex items-center gap-3" data-id="element-311">
                  <MessageCircle className="w-5 h-5 text-white shrink-0" data-id="element-312" />
                  <a href="https://wa.me/26773241613" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-313">
                    +267 73241613 (WhatsApp)
                  </a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-314">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-315" />
                <a href="mailto:bookings@maishahealth.co.bw" className="hover:text-brand-gold transition-colors" data-id="element-316">
                  bookings@maishahealth.co.bw
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-317">
                <Clock className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-318" />
                <span data-id="element-319">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-320" />
                  Sat: 9:00 AM - 1:00 PM
                  <br data-id="element-321" />
                  Sun: Closed
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-322">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-323">
              Newsletter
            </h3>
            <p className="text-slate-300 text-sm mb-4" data-id="element-324">
              Subscribe to receive health tips and clinic updates.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-325">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-brand-gold" data-id="element-326" />
              <Button variant="primary" fullWidth data-id="element-327">
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-328">
          <p className="text-slate-400 text-sm" data-id="element-329">
            © {new Date().getFullYear()} Maisha Medical Center Botswana. All
            rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-400" data-id="element-330">
            <span className="font-semibold text-slate-300" data-id="element-331">Useful Links:</span>
            <a href="https://www.bomra.co.bw/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-332">
              BoMRA
            </a>
            <a href="https://www.ilo.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-333">
              ILO
            </a>
            <a href="https://www.who.int/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-334">
              World Health Organization (WHO)
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function FloatingActions() {
  const whatsappMessage = encodeURIComponent('Hello Maisha Medical Center.\nI would like to book an appointment.\nName:\nPhone:\nPreferred Service:\nPreferred Date:\nPreferred Time:\n\nPlease assist me.');
  return <>
      {/* Desktop Floating */}
      <div className="hidden md:flex fixed bottom-8 right-8 flex-col gap-4 z-50" data-id="element-335">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-soft-lg hover:scale-110 transition-transform relative group" data-id="element-336">
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-337" />
          <MessageCircle className="w-7 h-7" data-id="element-338" />
          <span className="absolute right-full mr-4 bg-white text-slate-800 text-sm font-medium py-1.5 px-3 rounded-lg shadow-soft opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-339">
            Chat on WhatsApp
          </span>
        </a>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 px-4 py-3 flex items-center justify-between gap-3 pb-safe" data-id="element-340">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} className="flex-1 flex flex-col items-center justify-center gap-1 text-[#25D366]" data-id="element-341">
          <MessageCircle className="w-5 h-5" data-id="element-342" />
          <span className="text-[10px] font-medium" data-id="element-343">WhatsApp</span>
        </a>
        <Link to="/book" className="flex-[2] bg-brand-red text-white py-2.5 rounded-xl flex items-center justify-center gap-2 font-medium text-sm shadow-md" data-id="element-344">
          <Calendar className="w-4 h-4" data-id="element-345" />
          Book Now
        </Link>
        <a href="tel:+2676540244" className="flex-1 flex flex-col items-center justify-center gap-1 text-brand-navy" data-id="element-346">
          <Phone className="w-5 h-5" data-id="element-347" />
          <span className="text-[10px] font-medium" data-id="element-348">Call Us</span>
        </a>
      </div>
    </>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-349">
      <Header data-id="element-350" />
      <main className="flex-1 pt-[72px] md:pt-[128px] pb-16 md:pb-0" data-id="element-351">
        {children}
      </main>
      <Footer data-id="element-352" />
      <FloatingActions data-id="element-353" />
    </div>;
}